import type React from 'react';
import { ChevronDown } from '../ui/icons';
import { useT } from '../../i18n';

export interface PaymentCardProps {
  selectedMethod?: { id: string; name: string; icon?: string };
  onOpenModal: () => void;
  darkMode: boolean;
  getMethodIcon: (id: string, icon: string | undefined, size: number) => React.ReactNode;
  getMethodDisplayName: (id: string, name: string) => string;
}

export function PaymentCard({
  selectedMethod,
  onOpenModal,
  getMethodIcon,
  getMethodDisplayName,
}: PaymentCardProps) {
  const t = useT();
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpenModal}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onOpenModal(); }}
      className="flex items-center gap-[4px] p-4 transition-colors cursor-pointer card-press card-hover"
      style={{
        background: 'var(--t-surface)',
        borderRadius: 'var(--t-card-radius)',
      }}
    >
      <span className="text-[13px] flex-1" style={{ color: 'var(--t-text-secondary)', letterSpacing: '0.13px', lineHeight: '20px' }}>
        {t('payment.label')}
      </span>
      <span className="flex items-center gap-[6px]">
        {selectedMethod && (
          <>
            <span className="flex items-center justify-center" style={{ width: 20, height: 20 }}>
              {getMethodIcon(selectedMethod.id, selectedMethod.icon, 20)}
            </span>
            <span className="text-[14px] font-semibold" style={{ color: 'var(--t-text)', letterSpacing: '0.14px', lineHeight: '16px' }}>
              {getMethodDisplayName(selectedMethod.id, selectedMethod.name)}
            </span>
          </>
        )}
        {!selectedMethod && (
          <span className="text-[13px]" style={{ color: 'var(--t-text-muted)' }}>{t('payment.select')}</span>
        )}
        <ChevronDown />
      </span>
    </div>
  );
}
